module.exports = __webpack_public_path__ + "img/p9.95fdcb88.png";